(function () {
    "use strict";

    // @ngInject
    function NetworkImproveProfileControllerCtor($scope, $injector, $modalInstance, NetworkManager,AnalyticsService) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'NetworkImproveProfileController';

        this.modalInstance = $modalInstance;
        this.NetworkManager = NetworkManager;
        this.AnalyticsService = AnalyticsService;

        // AnalyticsService.trackPageView(this, AnalyticsService.analytics_events.network_unlock_hb_load);

    }

    Controllers.NetworkImproveProfileController = Class(Controllers.BaseController, {
        constructor: NetworkImproveProfileControllerCtor,

        cancelImproveProfile: function cancelImproveProfile(){
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_improve_profile_cancel);

            this.modalInstance.close();
        },

        GotoCreateProject: function GotoCreateProject(){
            this.modalInstance.close();

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.network_improve_profile_confirm);
            this.goToState(this.AppStates.root_network_create_project);

        }
    });
}());
